
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setSubmitMessage('Por favor, introduce un email válido');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5ogdk8f4392hm13odvg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      if (response.ok) {
        setSubmitMessage('¡Gracias por suscribirte!');
        setEmail('');
      } else {
        setSubmitMessage('Error al enviar. Inténtalo de nuevo.');
      }
    } catch (error) {
      setSubmitMessage('Error al enviar. Inténtalo de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gray-900 rounded-3xl mx-6 mb-6 overflow-hidden relative">
      <div className="absolute inset-0 flex items-end justify-center opacity-5">
        <div className="text-9xl font-bold text-white whitespace-nowrap">
          CONSTRUCCIÓN
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-3xl font-bold text-white mb-6">ASISTEC</h3>
          </div>

          <div>
            <h4 className="text-white text-base font-semibold mb-6">Servicios</h4>
            <ul className="space-y-4">
              <li><a href="#servicios" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Reformas Integrales</a></li>
              <li><a href="#servicios" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Construcción Nueva</a></li>
              <li><a href="#servicios" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Rehabilitación</a></li>
              <li><a href="#servicios" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Mantenimiento</a></li>
              <li><a href="#servicios" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Proyectos Comerciales</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-base font-semibold mb-6">Contacto</h4>
            <ul className="space-y-5">
              <li>
                <a href="tel:628752701" className="flex items-center gap-3 text-white text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  <i className="ri-phone-line"></i>
                  628 752 701
                </a>
              </li>
              <li>
                <a href="https://wa.me/34628752701" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white text-sm hover:text-green-400 transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line"></i>
                  628 752 701
                </a>
              </li>
              <li>
                <a href="mailto:correodeasistecsl@gmail.com" className="flex items-center gap-3 text-white text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  <i className="ri-mail-line"></i>
                  correodeasistecsl@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-white text-sm mb-2">Recibe presupuestos</p>
            <p className="text-white text-sm mb-6">y consejos gratuitos</p>
            
            <form onSubmit={handleSubmit} className="flex items-center gap-2" data-readdy-form id="newsletter-footer">
              <input 
                type="email"
                name="email"
                placeholder="Tu email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
                className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 text-white text-sm rounded-lg focus:outline-none focus:border-teal-500 transition-colors"
              />
              <button 
                type="submit"
                disabled={isSubmitting}
                className="flex items-center justify-center w-12 h-12 bg-white text-gray-900 rounded-full hover:bg-gray-100 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </form>
            {submitMessage && (
              <p className={`mt-2 text-sm ${submitMessage.includes('Gracias') ? 'text-green-400' : 'text-red-400'}`}>
                {submitMessage}
              </p>
            )}
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-4">
            <p className="text-gray-500 text-sm">
              © 2025 ASISTEC. Todos los derechos reservados.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 text-sm hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4 text-gray-500 text-xs">
            <a href="/politica-de-privacidad" className="hover:text-white transition-colors cursor-pointer">
              Política de Privacidad
            </a>
            <span>•</span>
            <a href="/aviso-legal" className="hover:text-white transition-colors cursor-pointer">
              Aviso Legal
            </a>
            <span>•</span>
            <a href="/politica-de-cookies" className="hover:text-white transition-colors cursor-pointer">
              Política de Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
